import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormControlName } from '@angular/forms';
import { AlertService } from '../../services/alert/alert.service';
import { LoadingService } from '../../services/loading/loading.service';
import { FrtRatesBidcycles, RateTypesSroPojo, FrtAcessorialsMaster, FrtRatesBidcyclesSros, FrtAccessorialMandatory, RateTypes } from 'src/app/shared/common-components/common-structure';
import { FrtRatesBidcyclesService } from 'src/app/services/frt-rates-bidcycles/frt-rates-bidcycles.service';
import { RateTypesSroService } from 'src/app/services/rate-types-sro/rate-types-sro.service';
import { RateTypesService } from 'src/app/services/rate-types/rate-types.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ConfirmationModalComponent} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {ExtendExpiryDatesComponent} from '../extend-expiry-dates/extend-expiry-dates.component';
import { RatefileOpenService } from 'src/app/services/ratefile-open/ratefile-open.service';
import { ControlKeys } from '../ratefile-open/control-keys';
import AppConstants from '../../shared/common-components/AppConstants';
import { HhgRatesBidcyclesDuplicateButtonRendererComponent } from './hhg-rates-bidcycles-duplicate-rate-filling';
import moment from 'moment';
import {CommonValidators} from '../../shared/common-components/common-validators';

@Component({
    selector: 'app-hhg-rates-bidcycles',
    templateUrl: './hhg-rates-bidcycles.component.html',
    styleUrls: ['./hhg-rates-bidcycles.component.css'],
    standalone: false
})
export class HhgRatesBidcyclesComponent implements OnInit {
  hhgRatesBidcyclesForm: UntypedFormGroup;

  frtRatesBidcycles: FrtRatesBidcycles;
  bidcyclesToPublish: FrtRatesBidcycles;
  public modalRef: BsModalRef;
  bsModalRef: BsModalRef;

  openMinDate: Date;
  closeMinDate: Date;
  bidOpenMinDate: Date;
  bidCloseMinDate: Date;
  effOpenMinDate: Date;
  effCloseMinDate: Date;

  allSros: RateTypesSroPojo[];
  sroListByRateType: RateTypesSroPojo[];
  assignedSroList:  RateTypesSroPojo[];
  /*allRatesList: RateTypes[];*/
  assignedRatesList: RateTypes[];

  selectedSroList: FrtRatesBidcyclesSros[];
  selectedAccList: FrtAccessorialMandatory[];

  assignedSroMasterIds: number[];
  assignedAccessorailMasterIds: number[];

  rateBidcyclesList: FrtRatesBidcycles[];
  itemsPerPage = 10;

  bidcycleError: boolean;
  bidOpenDateError: boolean;
  bidOpenDateErrorType: string;
  bidCloseDateError: boolean;
  bidCloseDateErrorType: string;

  effOpenDateError: boolean;
  effOpenDateErrorType: string;
  effCloseDateError: boolean;
  effCloseDateErrorType: string;
  showProduction: Boolean = false;
  showPreprod: Boolean = false;
  showPublish: Boolean = false;

  errorMessage: string;
  disableUpdate: boolean;
  isError: boolean;
  disableCreateBtn: boolean;
  updateAction: string;
  assignedIds: any[];
  pcMilerList: ControlKeys[];
  disableUpdateButton: boolean;
  disabled: boolean;
  updateBtnText: string;
  listHrs: {key: String, value:String}[] = [];
  hhgBidCycleClosedDate: Boolean = false;
  rateBidcyclesColumnDefs = [
    { headerName: 'Bidcycle Name', field: 'bidCycleName', width: 150,
      cellRenderer: params =>
        '<a tabindex="0">' + params.data.bidCycleName + '</a>',
      onCellClicked: event => this.onbidCycleNameSelected(event.data)
    },
    { headerName: 'Rate Filing  Open Date',  field: 'bidWindowOpenDate', width: 180, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      } },
    { headerName: 'Rate Filing Close Date', field: 'bidWindowCloseDate', width: 180, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      } },
    { headerName: 'Rate Effective Date',  field: 'rateEffectiveDate', width: 160, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      } },
    { headerName: 'Rate Expiry Date',  field: 'rateExpiryDate', width: 160, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      } },
    { headerName: 'Release to Prod Date',  field: 'releaseDateProduction', width: 175, filter: 'agTextColumnFilter', sortable: true,
      cellRenderer: (data) => {
        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
      } },
    {  headerName: 'Additional Text',  field: 'additionalInformation', width: 242 },
    {
      headerName: 'Duplicate Rate Filling', field: '', filter: '', sortable: true,
      cellRenderer: HhgRatesBidcyclesDuplicateButtonRendererComponent,
      cellRendererParams: {
        onClick: this.onDuplicatedBidCycle.bind(this),
        label: 'Duplicate Rate'
      },
    }
  ];
  domLayout;
  constructor(
    private frtRatesBidcyclesService: FrtRatesBidcyclesService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    private tmssLoader: LoadingService,
    private rateTypesSroService: RateTypesSroService,
    private rateTypesService: RateTypesService,
    private modalService: BsModalService,
    private ratefileOpenService: RatefileOpenService
  ) {

  }

  ngOnInit() {
    this.domLayout = 'autoHeight';

    /*
        this.rateTypesService.getRateTypesListByBusinessType('HHG').subscribe(
          allHhgRates => {
            this.allRatesList = allHhgRates;
          }, error => {
            this.alertService.error('Error while getting HHG Rate types. Please contact system administrator');
          });
    */

    this.frtRatesBidcyclesService.getHhgAll().subscribe(
      (rateBidcyclesList: any) => {
        this.rateBidcyclesList = rateBidcyclesList;
      }, (error: any) => {
        this.alertService.error('Error while retrieving Rate Bidcycles List');
      });

    this.rateTypesSroService.getHhgAll().subscribe(
      (sroList:any) => {
        this.allSros = sroList;
      }, (error: any) => {
        this.alertService.error('There was an error retrieving all SRO List');
      });
    this.ratefileOpenService.getPcMilerForHhg('HHG PCMiler Version', 'Main').
    subscribe((pcMilerList: any) => {
      this.pcMilerList = pcMilerList as ControlKeys[];
    }, error => {
      this.alertService.error('There was an error retrieving PcMiler Versions');
    });
    this.initValues();
    this.createForm();
    this.resetForm();
    this.generateHours();
    this.initCurrentTime();
    this.combineDateandTime();
  }

  initCurrentTime(){
    var hr = moment().hour();
    var min = moment().minute();
    var hrMin = ((hr<10)? ('0'+hr.toString()) : hr.toString()) + (( min < 30) ? ':00' : ':30');
    this.hhgRatesBidcyclesForm.get('timeSelection')?.setValue(hrMin);
  }

  generateHours(){
    for(var i = 0; i < 24; i ++){
      for(var j=0; j< 2; j++){
        var value = ((i<10)? '0' + i.toString() : i.toString()) + ':'+ ( j===0 ? '00' : (j * 30).toString());
        var obj = {key: value, value: value};
        this.listHrs.push(obj);
      }
    }
    this.listHrs.push({key:'24:00',value:'24:00'});
  }

  loadDateandTime(selectedBidCycleCloseddate: any){
    // var val = this.rowData[0].bidWindowCloseDate;
    const dateTime = moment(selectedBidCycleCloseddate)
    this.hhgRatesBidcyclesForm.get('bidCloseDate')?.setValue(dateTime.format('MM/DD/YYYY').toString());

    var hr = dateTime.hour();
    var min = dateTime.minute();
    var hrMin = ((hr<10)? ('0'+hr.toString()) : hr.toString()) + (( min < 30) ? ':00' : ':30');
    this.hhgRatesBidcyclesForm.get('timeSelection')?.setValue(hrMin);
  }

  combineDateandTime(){
    var comb = this.hhgRatesBidcyclesForm.controls['bidCloseDate'].value + ' ' + this.hhgRatesBidcyclesForm.controls['timeSelection'].value;
    return new Date(Date.parse(comb));
  }

  initValues() {
    this.updateAction = 'create';
    this.updateBtnText = 'Save';
    this.disableUpdate = true;
    this.disableCreateBtn = false;
    this.disabled = false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.bidOpenMinDate = today;
    this.bidCloseMinDate = today;
    this.effOpenMinDate = today;
    this. effCloseMinDate = today;
  }
  handleSroMultiDropdown(i: any) {
    if (!this.disabled) {
      this.assignedSroList.splice(i, 1);
      this.assignedSroList.sort((a, b) => a.sroId.localeCompare(b.sroId));
    }
  }
  handleRatesMultiDropdown(i: any) {
    if (!this.disabled) {
      this.assignedRatesList.splice(i, 1);
    }
  }
  createForm() {
    this.hhgRatesBidcyclesForm = this.fb.group({
      ratesBidcyclesId: new UntypedFormControl('', [Validators.required]),
      allSros: new UntypedFormControl('', [Validators.required]),
      assignedSros: new UntypedFormControl('', [Validators.required]),
      // allAccessorials: new FormControl('', [Validators.required]),
      // assignedAccessorials: new FormControl('', [Validators.required]),
      hhgSupplementalFiling: new UntypedFormControl('', [Validators.required]),
      bidCycle: new UntypedFormControl('', [Validators.required]),
      bidOpenDate: new UntypedFormControl('', [Validators.required]),
      // bidCloseDate: new UntypedFormControl('', [Validators.required]),
      bidCloseDate: new UntypedFormControl({value: moment().format('MM/DD/YYYY'), disabled: true},[Validators.required, CommonValidators.usDate]),
      timeSelection: new UntypedFormControl('',[Validators.required]),
      effOpenDate: new UntypedFormControl('', [Validators.required]),
      effCloseDate: new UntypedFormControl('', [Validators.required]),
      pcMiler: new UntypedFormControl('', [Validators.required]),
      addlText: new UntypedFormControl('', [Validators.maxLength(500)])
    });
  }

  resetForm() {
    this.updateAction = 'create';
    this.updateBtnText = 'Save';
    this.disableCreateBtn = false;
    this.showPublish = false;
    this.clearErrors();
    this.assignedSroList = [];
    this.assignedRatesList = [];
    this.disableUpdateButton = false;
    this.hhgRatesBidcyclesForm.controls['ratesBidcyclesId'].setValue(0);
    this.hhgRatesBidcyclesForm.controls['bidCycle'].setValue('');
    this.hhgRatesBidcyclesForm.controls['bidCycle'].enable();
    this.hhgRatesBidcyclesForm.controls['bidOpenDate'].setValue(new Date());

    this.generateHours();
    this.initCurrentTime();
    this.hhgRatesBidcyclesForm.controls['bidCloseDate'].setValue(moment().format('MM/DD/YYYY'));
    // this.hhgRatesBidcyclesForm.controls['bidCloseDate'].setValue(new Date());
    // this.hhgRatesBidcyclesForm.controls['allAccessorials'].setValue('');
    // this.hhgRatesBidcyclesForm.controls['assignedAccessorials'].setValue('');
    this.hhgRatesBidcyclesForm.controls['allSros'].setValue('');
    this.hhgRatesBidcyclesForm.controls['hhgSupplementalFiling'].setValue('');
    this.hhgRatesBidcyclesForm.controls['assignedSros'].setValue('');
    this.hhgRatesBidcyclesForm.controls['effOpenDate'].setValue('');
    this.hhgRatesBidcyclesForm.controls['effCloseDate'].setValue('');
    this.hhgRatesBidcyclesForm.controls['pcMiler'].setValue('');
    this.hhgRatesBidcyclesForm.controls['addlText'].setValue('');
    this.enableForm();
    this.clearValidators();
  }

  saveRateFileRec() {
    this.validateBidRecord();
    if (this.disableUpdate == true) {
      return;
    }
    this.populateBidRecord();
    (this.hhgRatesBidcyclesForm.controls['ratesBidcyclesId'].value == 0) ?
      this.createRateFile() : this.updateRateFile();
  }

  updateRateFile() {
    this.tmssLoader.show();
    this.frtRatesBidcyclesService.updateHhgRatesBidcycles(this.frtRatesBidcycles)
      .subscribe(data => {
          // console.log('Response is ' + data);
          this.alertService.success('Rates Bidcycles has been updated');
          this.disableCreateBtn = true;
          this.frtRatesBidcyclesService.getHhgAll().subscribe(
            rateBidcyclesList => {
              this.rateBidcyclesList = rateBidcyclesList;
            }, error => {
              this.alertService.error('Error while retrieving Rate Bidcycles List');
            });
          this.tmssLoader.hide();
        },
        (error) => {
          // console.log('There was an error while updating rates bidcycles' + JSON.stringify(error));
          this.alertService.error('There was an error while updating rates bidcycles');
          this.tmssLoader.hide();
        });


  }
  createRateFile() {
    this.bsModalRef = this.modalService.show(ConfirmationModalComponent);
    this.bsModalRef.content.question = 'You are about to open a rate filing window. Please click ok to continue or  cancel to go back.';
    this.bsModalRef.content.title = 'Open Rate Filing Window';
    this.bsModalRef.content.confirmText = 'Ok';
    this.bsModalRef.content.cancelText = 'Cancel';
    this.bsModalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.frtRatesBidcycles.publishEmail = 0;
        this.tmssLoader.show();
        this.frtRatesBidcyclesService.createHhgRatesBidcycles(this.frtRatesBidcycles)
          .subscribe(data => {
              // console.log(data);
              this.alertService.success('Rates Bidcycles has been created');
              this.disableCreateBtn = true;
              this.frtRatesBidcyclesService.getHhgAll().subscribe(
                rateBidcyclesList => {
                  this.rateBidcyclesList = rateBidcyclesList;
                }, error => {
                  this.alertService.error('Error while retrieving Rate Bidcycles List');
                });
              this.tmssLoader.hide();
              this.showPublish = true;
              /*
              this.frtRatesBidcyclesService.sendHhgCarrierEmails(this.frtRatesBidcycles)
                .subscribe(date => {
                  console.log('Response email is ' + data);
                });
               */
            },
            (error) => {
              // console.log('There was an error while creating rates bidcycles' + JSON.stringify(error));
              this.alertService.error('There was an error while creating rates bidcycles');
              this.tmssLoader.hide();
            });
      }
    }, () => {
      this.alertService.warn('Opening a rate filing window has been cancelled.');
    });
  }
  validateBidRecord() {
    const bidCycleName = this.hhgRatesBidcyclesForm.controls['bidCycle'].value;
    const bidWindowOpenDate = this.hhgRatesBidcyclesForm.controls['bidOpenDate'].value;
    // const bidWindowCloseDate = this.hhgRatesBidcyclesForm.controls['bidCloseDate'].value;
    const bidWindowCloseDate = this.combineDateandTime();
    const rateEffectiveDate = this.hhgRatesBidcyclesForm.controls['effOpenDate'].value;
    const rateExpiryDate = this.hhgRatesBidcyclesForm.controls['effCloseDate'].value;
    this.disableUpdate = true;
    if (bidCycleName === null || bidCycleName === '') {
      this.errorMessage = 'Bid Cycle name is required.';
      this.isError = true;
      return;
    }
    if (this.bidcycleError) {
      this.errorMessage = 'Bid Cycle name is already available.Please use another name.';
      this.isError = true;
      return;
    }
    if (bidWindowOpenDate === null || bidWindowOpenDate === '') {
      this.errorMessage = 'Rate Filing Open Date is required.';
      this.isError = true;
      return;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (bidWindowOpenDate < today && this.updateBtnText === 'Save') {
      this.errorMessage = 'Rate Filing Open Date should be on or after today.';
      return;
    }
    if (bidWindowCloseDate === null) {
      this.errorMessage = 'Rate Filing Close Date is required.';
      this.isError = true;
      return;
    }
    if (bidWindowOpenDate > bidWindowCloseDate) {
      this.errorMessage = 'Rate Filing Close Date should be on or after Rate Filing Open Date.';
      this.isError = true;
      return;
    }
    if (this.assignedSroList.length < 1) {
      this.errorMessage = 'Please select atleast on SRO.';
      this.isError = true;
      return;
    }
    /*if (this.assignedRatesList.length < 1) {
      this.errorMessage = "Please select atleast on Rate Type.";
      this.isError = true;
      return;
    }*/
    if (rateEffectiveDate === null || rateEffectiveDate === '') {
      this.errorMessage = 'Rate Effective Date is required.';
      this.isError = true;
      return;
    }
    if (rateExpiryDate === null || rateExpiryDate === '') {
      this.errorMessage = 'Rate Expiry Date is required.';
      this.isError = true;
      return;
    }

    this.isError = false;
    this.disableUpdate = false;

  }

  populateBidRecord() {
    this.frtRatesBidcycles = new FrtRatesBidcycles();
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.frtRatesBidcycles.ratesBidcyclesId = this.hhgRatesBidcyclesForm.controls['ratesBidcyclesId'].value;
    this.frtRatesBidcycles.bidCycleName = this.hhgRatesBidcyclesForm.controls['bidCycle'].value;
    this.frtRatesBidcycles.bidWindowOpenDate = this.hhgRatesBidcyclesForm.controls['bidOpenDate'].value;
    // this.frtRatesBidcycles.bidWindowCloseDate = this.hhgRatesBidcyclesForm.controls['bidCloseDate'].value;
    this.frtRatesBidcycles.bidWindowCloseDate = this.combineDateandTime();
    this.frtRatesBidcycles.rateEffectiveDate = this.hhgRatesBidcyclesForm.controls['effOpenDate'].value;
    this.frtRatesBidcycles.rateExpiryDate = this.hhgRatesBidcyclesForm.controls['effCloseDate'].value;
    this.frtRatesBidcycles.businessType = 'HHG';
    this.frtRatesBidcycles.updateProgram = '';
    this.frtRatesBidcycles.pcMilerVersion = this.hhgRatesBidcyclesForm.controls['pcMiler'].value;
    this.frtRatesBidcycles.additionalInformation = this.hhgRatesBidcyclesForm.controls['addlText'].value;
    this.frtRatesBidcycles.hhgSupplementalFiling = this.hhgRatesBidcyclesForm.controls['hhgSupplementalFiling'].value;
    //this.frtRatesBidcycles.publishEmail = 0;
    this.frtRatesBidcycles.updateDate = today;
    this.frtRatesBidcycles.updateId = 0;
    this.frtRatesBidcycles.userId = 0;
    this.assignedSroMasterIds = [];
    this.assignedAccessorailMasterIds = [];
    this.loadSelectedSros();
    // console.log(this.assignedSroMasterIds);
    this.frtRatesBidcycles.assignedSroMasterIds = this.assignedSroMasterIds;
    this.loadSelectedAccs();
    this.frtRatesBidcycles.assignedAccessorailMasterIds = this.assignedAccessorailMasterIds;

  }
  clearPage() {
    this.resetForm();
  }

  publishBidcycle(){
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you sure, you want publish the current bidcycle to TSPs? Click Yes to proceed, No to go back.';
    this.modalRef.content.title = 'Publish the current bidcycle to TSPs';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.showPublish = false;
    this.populateBidRecord();
    this.frtRatesBidcycles.publishEmail = 1;
    // console.log(this.frtRatesBidcycles);
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.rateBidcyclesList.forEach(bid => {
          if (bid.bidCycleName == this.frtRatesBidcycles.bidCycleName) {
            this.frtRatesBidcycles.ratesBidcyclesId = bid.ratesBidcyclesId;
            bid.publishEmail = 1;
            // console.log(this.frtRatesBidcycles);
          }
        });
        this.tmssLoader.show();
        this.frtRatesBidcyclesService.sendHhgCarrierEmails(this.frtRatesBidcycles).subscribe(res => {
          this.tmssLoader.hide();
          this.alertService.success('Emails are being sent out to TSPs.');
        }, error => {
          this.tmssLoader.hide();
          // console.log(error);
          this.alertService.error('Publish Rate Bid Cycle failed');
        });
      }
    });

  }

  releaseToProduction() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you sure, you want release the current bidcycle to production? Click Yes to proceed, No to go back.';
    this.modalRef.content.title = 'Release the current bidcycle to production';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.frtRatesBidcyclesService.startReleaseToProduction(this.hhgRatesBidcyclesForm.get('ratesBidcyclesId').value, 'HHG').subscribe(res => {
          this.tmssLoader.hide();
          this.alertService.success('Prod Carry Forward Success');
        }, error => {
          this.tmssLoader.hide();
          this.alertService.error('Error in Prod Carry Forward');
        });
      }
    });
  }

  // release to preprod for moving rates from prod to preprod for rates validation
  releaseToPreprod() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you sure, you want release the selected bidcycle to preprod? Click Yes to proceed, No to go back.';
    this.modalRef.content.title = 'Release the selected bidcycle to preprod';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.tmssLoader.show();
        this.frtRatesBidcyclesService.startReleaseToPreprod(this.hhgRatesBidcyclesForm.get('ratesBidcyclesId').value, 'HHG').subscribe(res => {
          this.tmssLoader.hide();
          this.alertService.success('Preprod copy process has started. Please wait for the confirmation email.');
        }, error => {
          this.tmssLoader.hide();
          this.alertService.error('Error in Prod Carry Forward');
        });
      }
    });
  }

  loadSelectedSros() {
    if (this.assignedSroList.length > 0) {
      this.assignedSroList.forEach(x => {
        this.assignedSroMasterIds.push( x.sroMasterId);
      });
    }
  }

  loadSelectedAccs() {
    if (this.assignedRatesList.length > 0) {
      this.assignedRatesList.forEach(x => {
        this.assignedAccessorailMasterIds.push(x.rateTypeId);
      });
    }
  }

  onCycleNameChange(event: any) {
    const cycleName = event.target.value;
    this.bidcycleError = false;
    this.isError = false;
    this.rateBidcyclesList.forEach(bid => {
      if (bid.bidCycleName == cycleName) {
        this.bidcycleError = true;
      }
    });
  }

  bidOpenDateChange(bidOpenDate: any) {
    if (bidOpenDate === null) {
      return false;
    }
    // const bidCloseDate = this.hhgRatesBidcyclesForm.get('bidCloseDate').value;
    const bidCloseDate = this.combineDateandTime();
    this.isError = false;
    this.bidOpenDateError = false;
    this.bidOpenDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (bidOpenDate < today) {
      this.bidOpenDateError = true;
      this.bidOpenDateErrorType = 'A';
    }
    if ((bidCloseDate !== null) &&
      (bidOpenDate > bidCloseDate)) {
      this.bidOpenDateError = true;
      this.bidOpenDateErrorType = 'B';
    }

    if ((bidOpenDate !== '') &&
      (bidCloseDate !== null) &&
      (this.bidOpenDateError == false)) {
      this.rateTypesSroService.getHhgRateTypeSrosByBidDate(bidOpenDate, bidCloseDate).subscribe(
        sroListByRateType => {
          this.sroListByRateType = sroListByRateType ? sroListByRateType.sort((a: any, b:any) => a.sroId.localeCompare(b.sroId)) : [];
        }, error => {
          this.alertService.error('There was an error retrieving SRO List by Rate Type');
        });
    }
  }
  bidCloseDateChange(bidCloseDate: any) {

    this.hhgRatesBidcyclesForm.controls['bidCloseDate'].setValue(bidCloseDate.detail['value']);

    if (bidCloseDate === null){
      return false;
    }
    bidCloseDate = this.combineDateandTime();
    const currentDate = new Date();
    this.showProduction = (currentDate > bidCloseDate);
    this.showPreprod = (currentDate > bidCloseDate);
    if (bidCloseDate ===  null) {
      return;
    }
    const bidOpenDate = this.hhgRatesBidcyclesForm.get('bidOpenDate').value;
    // const bidOpenDate = this.combineDateandTime();
    const effOpenDate = this.hhgRatesBidcyclesForm.get('effOpenDate').value;
    this.isError = false;
    this.bidCloseDateError = false;
    this.bidCloseDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (bidOpenDate < today) {
      return;
    }
    if (bidCloseDate < today) {
      this.bidCloseDateError = true;
      this.bidCloseDateErrorType = 'A';
    }
    if (bidCloseDate < this.hhgRatesBidcyclesForm.get('bidOpenDate').value) {
      this.bidCloseDateError = true;
      this.bidCloseDateErrorType = 'B';
    }
    if ( (effOpenDate !== '' ) && effOpenDate < bidCloseDate) {
      this.effOpenDateError = true;
      this.effOpenDateErrorType = 'B';
    } else {
      this.effOpenDateError = false;
      this.effOpenDateErrorType = '';
    }
    if ((bidCloseDate !== '') &&
      (this.hhgRatesBidcyclesForm.get('bidOpenDate').value !== '') &&
      (this.bidCloseDateErrorType == '')) {
      // console.log(bidOpenDate + 'sdadas'+ bidCloseDate);
      this.rateTypesSroService.getHhgRateTypeSrosByBidDate(bidOpenDate, bidCloseDate).subscribe(
        sroListByRateType => {
          this.sroListByRateType = sroListByRateType ? sroListByRateType.sort((a, b) => a.sroId.localeCompare(b.sroId)) : [];
        }, error => {
          this.alertService.error('There was an error retrieving SRO List by Rate Type');
        });
    }
  }

  effOpenDateChange(effOpenDate: any) {
    if (effOpenDate === '' || effOpenDate === null) {
      return;
    }
    this.isError = false;
    // const bidCloseDate = this.hhgRatesBidcyclesForm.get('bidCloseDate').value;
    const bidCloseDate = this.combineDateandTime();
    this.effOpenDateError = false;
    this.effOpenDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bidOpenDate = this.hhgRatesBidcyclesForm.get('bidOpenDate').value;
    // console.log(bidCloseDate);
    // console.log(today);
    if (bidOpenDate < today) {
      return;
    }
    if (effOpenDate < today) {
      this.effOpenDateError = true;
      this.effOpenDateErrorType = 'A';
    }
    if (effOpenDate < bidCloseDate) {
      this.effOpenDateError = true;
      this.effOpenDateErrorType = 'B';
    }
  }
  effCloseDateChange(effCloseDate: any) {
    if (effCloseDate === '' || effCloseDate === null) {
      return;
    }
    this.isError = false;
    const effOpenDate = this.hhgRatesBidcyclesForm.get('effOpenDate').value;
    this.effCloseDateError = false;
    this.effCloseDateErrorType = '';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const bidOpenDate = this.hhgRatesBidcyclesForm.get('bidOpenDate').value;
    if (bidOpenDate < today) {
      return;
    }
    if (effCloseDate < today) {
      this.effCloseDateError = true;
      this.effCloseDateErrorType = 'A';
    }
    if ((effOpenDate !== '') && (effCloseDate < effOpenDate)) {
      this.effCloseDateError = true;
      this.effCloseDateErrorType = 'B';
    }
  }
  onPcMilerChange(pcMilerVersion: any) {

  }

  onAddlText(addlText: any) {

  }

  onbidCycleNameSelected(selectedBidCycle: any) {
    this.resetForm();
    this.updateAction = 'update';
    this.updateBtnText = 'Update';
    this.disableCreateBtn = false;
    // this.disableUpdateButton = false;
    this.showPublish = false;
    this.clearErrors();
    this.hhgRatesBidcyclesForm.controls['ratesBidcyclesId'].setValue(selectedBidCycle.ratesBidcyclesId);
    this.hhgRatesBidcyclesForm.controls['bidCycle'].setValue(selectedBidCycle.bidCycleName);
    this.hhgRatesBidcyclesForm.controls['hhgSupplementalFiling'].setValue(selectedBidCycle.hhgSupplementalFiling);
    this.hhgRatesBidcyclesForm.controls['bidCycle'].disable();
    let dateStringCloseDate = selectedBidCycle.bidWindowCloseDate;
    const bidWindowCloseDate = new Date(dateStringCloseDate);
    this.hhgRatesBidcyclesForm.controls['bidCloseDate'].setValue(moment(bidWindowCloseDate).format('MM/DD/YYYY').toString()) ;
    const currentDate = new Date();

     let dateString = selectedBidCycle.bidWindowOpenDate;
    const bidWindowOpenDate = new Date(dateString);
    this.hhgRatesBidcyclesForm.controls['bidOpenDate'].setValue(bidWindowOpenDate) ;

    
    // this.showProduction = (currentDate > this.hhgRatesBidcyclesForm.get('bidCloseDate').value) && !(AppConstants.isNotNullCondition(selectedBidCycle.releaseDateProduction));
    // this.showPreprod = (currentDate > this.hhgRatesBidcyclesForm.get('bidCloseDate').value) && !(AppConstants.isNotNullCondition(selectedBidCycle.releaseDatePreprod));

    this.loadDateandTime(bidWindowCloseDate);
    this.showProduction = (currentDate > new Date(selectedBidCycle.bidWindowCloseDate)) && !(AppConstants.isNotNullCondition(selectedBidCycle.releaseDateProduction));
    this.showPreprod = (currentDate > new Date(selectedBidCycle.bidWindowCloseDate)) && !(AppConstants.isNotNullCondition(selectedBidCycle.releaseDatePreprod));

    if (AppConstants.isNotNullCondition(bidWindowOpenDate) && AppConstants.isNotNullCondition(bidWindowCloseDate)) {
      this.rateTypesSroService.getHhgRateTypeSrosByBidDate(bidWindowOpenDate, bidWindowCloseDate).subscribe(
        sroListByRateType => {
          this.sroListByRateType = sroListByRateType ? sroListByRateType.sort((a: any, b: any) => a.sroId.localeCompare(b.sroId)) : [];
        }, error => {
          this.alertService.error('There was an error retrieving SRO List by Rate Type');
        });
    }
    this.assignedSroList = [];
    this.assignedIds = selectedBidCycle.assignedSroMasterIds;
    this.assignedIds.forEach(e => {
      this.populateSelectedSros(e);
    });

    this.hhgRatesBidcyclesForm.controls['assignedSros'].setValue(this.assignedSroList) ;

    this.assignedRatesList = [];
    this.assignedIds = selectedBidCycle.assignedAccessorailMasterIds;
    /*    this.assignedIds.forEach(e => {
          this.onAllRatesChange(e);
        });*/

    this.hhgRatesBidcyclesForm.controls['assignedSros'].setValue(this.assignedRatesList);

    dateString = selectedBidCycle.rateEffectiveDate;
    const rateEffectiveDate = new Date(dateString);
    this.hhgRatesBidcyclesForm.controls['effOpenDate'].setValue(rateEffectiveDate);

    dateString = selectedBidCycle.rateExpiryDate;
    const rateExpiryDate = new Date(dateString);
    this.hhgRatesBidcyclesForm.controls['effCloseDate'].setValue(rateExpiryDate);

    const intValue = selectedBidCycle.pcMilerVersion;
    const pcmilerVersion = new Number(intValue);
    this.hhgRatesBidcyclesForm.controls['pcMiler'].setValue(pcmilerVersion);
    this.hhgRatesBidcyclesForm.controls['addlText'].setValue(selectedBidCycle.additionalInformation);
    this.showPublish = selectedBidCycle.publishEmail === 0;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    /*
    (this.hhgRatesBidcyclesForm.controls['bidOpenDate'].value < today) ?
              this.disableForm() : this.enableForm();
    */
    this.enableForm();
    if(this.hhgRatesBidcyclesForm.controls['bidCloseDate'].value < today) {
      this.disableUpdateButton = true;
      this.disableForm();
    } else {
      this.disableUpdateButton = false;
      // if(this.hhgRatesBidcyclesForm.controls['bidOpenDate'].value < today)
      if (new Date() > this.hhgRatesBidcyclesForm.controls['bidOpenDate'].value) {
        this.disablePartialForm();
      }
    }
  }
  disablePartialForm() {
    this.disabled = true;
    this.hhgRatesBidcyclesForm.controls['bidCycle'].disable();
    this.hhgRatesBidcyclesForm.controls['bidOpenDate'].disable();
    this.hhgRatesBidcyclesForm.controls['allSros'].disable();
    this.hhgRatesBidcyclesForm.controls['assignedSros'].disable();
    this.hhgRatesBidcyclesForm.controls['hhgSupplementalFiling'].disable();
    // this.hhgRatesBidcyclesForm.controls['assignedAccessorials'].disable();
    // this.hhgRatesBidcyclesForm.controls['allAccessorials'].disable();
    this.hhgRatesBidcyclesForm.controls['pcMiler'].disable();
    this.clearValidators();
  }
  disableForm() {
    this.disabled = true;
    this.hhgRatesBidcyclesForm.controls['bidCycle'].disable();
    this.hhgRatesBidcyclesForm.controls['bidOpenDate'].disable();
    this.hhgRatesBidcyclesForm.controls['bidCloseDate'].disable();
    this.hhgRatesBidcyclesForm.controls['allSros'].disable();
    this.hhgRatesBidcyclesForm.controls['assignedSros'].disable();
    this.hhgRatesBidcyclesForm.controls['hhgSupplementalFiling'].disable();
    this.hhgRatesBidcyclesForm.controls['bidCloseDate'].disable();
    this.hhgBidCycleClosedDate = true;
    this.hhgRatesBidcyclesForm.controls['timeSelection'].disable();
    // this.hhgRatesBidcyclesForm.controls['assignedAccessorials'].disable();
    // this.hhgRatesBidcyclesForm.controls['allAccessorials'].disable();
    this.hhgRatesBidcyclesForm.controls['effOpenDate'].disable();
    this.hhgRatesBidcyclesForm.controls['effCloseDate'].disable();
    this.hhgRatesBidcyclesForm.controls['pcMiler'].disable();
    this.hhgRatesBidcyclesForm.controls['addlText'].disable();
    this.clearValidators();
  }

  clearValidators() {
    this.hhgRatesBidcyclesForm.controls['bidCycle'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['bidOpenDate'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['bidCloseDate'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['allSros'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['assignedSros'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['hhgSupplementalFiling'].clearValidators();
    // this.hhgRatesBidcyclesForm.controls['assignedAccessorials'].clearValidators();
    // this.hhgRatesBidcyclesForm.controls['allAccessorials'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['effOpenDate'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['effCloseDate'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['pcMiler'].clearValidators();
    this.hhgRatesBidcyclesForm.controls['addlText'].clearValidators();

  }
  enableForm() {
    this.disabled = false;
    this.hhgRatesBidcyclesForm.controls['bidOpenDate'].enable();

    this.hhgRatesBidcyclesForm.controls['timeSelection'].enable();
    // this.hhgRatesBidcyclesForm.controls['dateSelection'].enable();
    this.hhgBidCycleClosedDate = false;
    this.hhgRatesBidcyclesForm.controls['bidCloseDate'].enable();
    this.hhgRatesBidcyclesForm.controls['allSros'].enable();
    this.hhgRatesBidcyclesForm.controls['assignedSros'].enable();
    this.hhgRatesBidcyclesForm.controls['hhgSupplementalFiling'].enable();
    // this.hhgRatesBidcyclesForm.controls['assignedAccessorials'].enable();
    // this.hhgRatesBidcyclesForm.controls['allAccessorials'].enable();
    this.hhgRatesBidcyclesForm.controls['effOpenDate'].enable();
    this.hhgRatesBidcyclesForm.controls['effCloseDate'].enable();
    this.hhgRatesBidcyclesForm.controls['pcMiler'].enable();
    this.hhgRatesBidcyclesForm.controls['addlText'].enable();
  }

  clearErrors() {
    this.bidcycleError = false;
    this.bidOpenDateError = false;
    this.bidOpenDateErrorType = '';
    this.bidCloseDateError = false;
    this.bidCloseDateErrorType = '';
    this.effOpenDateError = false;
    this.effOpenDateErrorType = '';
    this.effCloseDateError = false;
    this.effCloseDateErrorType = '';
    this.isError = false;
  }

  moveItems() {
    const sourceArray = this.hhgRatesBidcyclesForm.get('allSros').value;
    if(!AppConstants.isNotNullCondition(sourceArray)) return;
    let rtsPojoArray: RateTypesSroPojo[] = [];
    const destinationArray = AppConstants.isNotNullCondition(this.assignedSroList) ? this.assignedSroList : [];
    this.sroListByRateType.forEach(e => {
      sourceArray.forEach(y => {
        if (e.sroMasterId === y) {
          rtsPojoArray.push(e);
        }
      });
    });
    this.assignedSroList = Array.from(new Set(destinationArray.concat(rtsPojoArray))).sort((a, b) => a.sroId.localeCompare(b.sroId));
    // console.log(this.assignedSroList);
  }

  onAllSrosChange(sroMasterId: any) {
    let rtsPojo: RateTypesSroPojo;
    this.sroListByRateType.forEach(e => {
      if (e.sroMasterId == sroMasterId) {
        rtsPojo = e;
      }
    });

    let itemPresent = false;
    this.assignedSroList.forEach(x => {
      if (x.sroMasterId == sroMasterId) {
        itemPresent = true;
      }
    });
    if (!itemPresent) {
      this.assignedSroList.push(rtsPojo);
    }
  }

  populateSelectedSros(sroMasterId: any) {
    let rtsPojo: RateTypesSroPojo;
    this.allSros.forEach(e => {
      if (e.sroMasterId == sroMasterId) {
        rtsPojo = e;
      }
    });

    let itemPresent = false;
    this.assignedSroList.forEach(x => {
      if (x.sroMasterId == sroMasterId) {
        itemPresent = true;
      }
    });
    if (!itemPresent) {
      this.assignedSroList.push(rtsPojo);
      this.assignedSroList?.sort((a, b) => a.sroId.localeCompare(b.sroId));
    }
  }

  openExtendRates() {
    const initialState = {
      businessType : 'HHG'
    };
    this.modalRef = this.modalService.show(ExtendExpiryDatesComponent, {initialState, backdrop: 'static', class: 'modal-lg' });
  }

  onDuplicatedBidCycle(selectedBidCycle: any) {
    // console.log("must be here when the button is clicked");
    this.resetForm();
    this.updateAction = 'create';
    this.updateBtnText = 'Duplicate';
    this.disableUpdate = true;
    this.disableCreateBtn = false;
    this.disabled = false;
    this.showPublish = false;
    this.disableUpdateButton =false;
    this.clearErrors();
    let dateString = selectedBidCycle.bidWindowOpenDate;
    const bidWindowOpenDate = new Date(dateString);
    dateString = selectedBidCycle.bidWindowCloseDate;
    const bidWindowCloseDate = new Date(dateString);
    if (AppConstants.isNotNullCondition(bidWindowOpenDate) && AppConstants.isNotNullCondition(bidWindowCloseDate)) {
      this.rateTypesSroService.getHhgRateTypeSrosByBidDate(bidWindowOpenDate, bidWindowCloseDate).subscribe(
        sroListByRateType => {
          this.sroListByRateType = sroListByRateType ? sroListByRateType.sort((a, b) => a.sroId.localeCompare(b.sroId)) : [];
        }, error => {
          this.alertService.error('There was an error retrieving SRO List by Rate Type');
        });
    }
    this.assignedSroList = [];
    this.assignedIds = selectedBidCycle.assignedSroMasterIds;
    this.assignedIds.forEach(e => {
      this.populateSelectedSros(e);
    });

    this.hhgRatesBidcyclesForm.controls['assignedSros'].setValue(this.assignedSroList);
    this.hhgRatesBidcyclesForm.controls['ratesBidcyclesId'].value == 0;
  }

}
